import { createSelector } from "reselect";
import translateObject from "../../utilities/translateObject";
import getRegion from "./getRegion";

const getSportTypes = state => state.sportTypes.data;

const selectSportTypes = createSelector(
  [getRegion, getSportTypes],
  (region, sportTypes) => {
    return sportTypes.map(sportType => {
      return Object.assign({}, sportType, {
        name: translateObject(sportType.name, region.language),
      });
    });
  }
);

export default selectSportTypes;
